let auth0Token: string | null = null;

export const setAuth0Token = (token: string) => {
  auth0Token = token;
};

export const getAuth0Token = () => {
  return auth0Token;
};
